var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnWarningSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6747_139301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.21817 1.82855C7.01009 0.45689 8.98991 0.456892 9.78183 1.82855L15.7213 12.116C16.5132 13.4876 15.5233 15.2022 13.9394 15.2022H2.06055C0.4767 15.2022 -0.513206 13.4876 0.278721 12.116L6.21817 1.82855Z",
    fill: "#DB0046"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99988 12.459V12.4653",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99988 4.91406L7.99988 6.97155L7.99988 9.02903",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6747_139301"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnWarningSolid);
export default __webpack_public_path__ + "static/media/icn_warning_solid.5b9ac01a03c169eb5360736bd3280d8b.svg";
export { ForwardRef as ReactComponent };